import { useMemo } from "react";
import { Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SERVICE_TYPES, statusOf } from "@/lib/services";

export const ALL = "todos";
export const EMPTY_FILTER = { q: "", type: ALL, status: ALL };

const STATUS_OPTIONS = [[ALL, "Toda situação"], ["agendado", "Agendado"], ["breve", "Vence em breve"], ["vencido", "Vencido"], ["realizado", "Realizado"]];
const typeOptions = () => [[ALL, "Todos os serviços"], ...Object.entries(SERVICE_TYPES).map(([k, t]) => [k, t.label])];
const norm = (v) => (v || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const applyFilter = (services, f, today) => {
  const q = norm(f.q.trim());
  return services.filter((s) => (f.type === ALL || s.service_type === f.type)
    && (f.status === ALL || statusOf(s, today).key === f.status)
    && (!q || norm(s.client_name).includes(q) || norm(s.service_name || SERVICE_TYPES[s.service_type]?.label).includes(q)));
};

const Pick = ({ value, onChange, options, testid }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="h-10 w-full bg-slate-900 sm:w-52" data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent className="border-slate-700 bg-slate-900">
      {options.map(([k, label]) => <SelectItem key={k} value={k} data-testid={`${testid}-${k}`}>{label}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const CalendarFilters = ({ f, setF, shown, total, typesVersion }) => {
  const active = f.q || f.type !== ALL || f.status !== ALL;
  const types = useMemo(typeOptions, [typesVersion]);
  return (
    <div className="mb-4 flex flex-col gap-2 rounded-xl border border-slate-700/60 bg-slate-900/60 p-3 sm:flex-row sm:flex-wrap sm:items-center" data-testid="calendar-filters">
      <div className="relative sm:w-72">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
        <Input value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} placeholder="Buscar cliente ou serviço" className="h-10 bg-slate-900 pl-9" data-testid="calendar-search-input" />
      </div>
      <Pick value={f.type} onChange={(type) => setF({ ...f, type })} testid="calendar-type-filter" options={types} />
      <Pick value={f.status} onChange={(status) => setF({ ...f, status })} testid="calendar-status-filter" options={STATUS_OPTIONS} />
      {active && (
        <>
          <span className="text-xs text-slate-400" data-testid="calendar-filter-count">{shown} de {total} serviço(s)</span>
          <Button variant="ghost" size="sm" onClick={() => setF(EMPTY_FILTER)} className="h-9 rounded-full text-slate-300" data-testid="calendar-filter-clear"><X className="mr-1 h-4 w-4" /> Limpar</Button>
        </>
      )}
    </div>
  );
};
